import { userAssignerRootStore } from './user-assigner-store';

const useUserAssignerStore = () => userAssignerRootStore.getStore().userAssignerStore;

export default useUserAssignerStore;
